module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "introduction"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "chapsub"
  }, [_c('em', [_c('strong', [_vm._v("Before Korn: A Century of Jewish Historical"), _c('br'), _vm._v("Writing about the American Civil War")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_c('em', [_c('strong', [_vm._v("Adam Mendelsohn")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The history of scholarship on the American Jewish experience of the Civil War can be neatly divided into two eras. From the 1880s—when Jewish participation in the conflict first attracted sustained attention—until 1950, the field was dominated by enthusiastic amateur historians. A second era began in 1951, when Bertram Korn, an ordained rabbi who had served as a Marine Corps chaplain in the latter stages of World War II, published "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(", based on his doctoral thesis at Hebrew Union College in Cincinnati."), _c('a', {
    attrs: {
      "id": "introductionfnote1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote1introduction"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In spite of producing several other significant volumes, Korn is best remembered for this single work written at the beginning of his career. The book simultaneously debunked the thriving mythology about Jewish involvement in the war and raised new questions concerning the challenges that the conflict posed to Jews on both sides of the struggle. As the present volume demonstrates, Korn’s research agenda continues to influence and define major work on Jews and the Civil War to this day."), _c('a', {
    attrs: {
      "id": "introductionfnote2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote2introduction"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite a flowering of scholarship in fields first sown by Korn, an earlier hagiographic tradition, described in detail in this introduction, has proven remarkably resilient. Several specious themes have proven difficult to uproot from collective memory and popular history. This introduction examines the genesis of this earlier literature on Jews and the Civil War "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("and speculates on the reasons why a number of factually incorrect but alluring ideas have endured. It focuses on the period before American Jewish history became an academic field and explores how amateur historians crafted a consensual understanding of the meaning and importance of the Civil War for Jews. For the most part, this was popular history written with one eye closely focused on the present. These historical works—many of them textbooks and primers—were written for broad audiences, intended to introduce a primarily immigrant population to American Jewish history, to instill pride and create a common past, and to counter charges that Jews were unworthy of their American freedoms.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_vm._v("This introduction was adapted from "), _c('em', [_vm._v("American Jewish History")]), _vm._v(" 92:4 (2007): 438–454, copyright © 2007 by the American Jewish Historical Society; reprinted with permission from The Johns Hopkins University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All these filiopietistic tendencies came under sustained assault in the decade following the Holocaust, as the professionally trained students of Salo W. Baron at Columbia University and Jacob Rader Marcus at Hebrew Union College began to challenge and rewrite the standard narratives of the American Jewish experience. Bertram Korn was trained by Marcus and adopted his mentor’s empirical methodology. His first book was squarely aimed at a bastion of mythologizing and romanticism in American Jewish historical writing: the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Korn composed his landmark book, the Civil War had spent decades as one of the most contested areas in American historiography. Barely had the guns fallen silent at Appomattox, indeed, before politicians, polemicists, and historians mustered to refight the political battles of the war. Even though the Confederacy’s armies lost on the battlefields, it won many of these initial intellectual skirmishes."), _c('a', {
    attrs: {
      "id": "introductionfnote3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote3introduction"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v("Much of this early debate was fiercely partisan and occurred outside the academy. Although the period following the conflict was marked by the slow and steady institutionalization and professionalization of the field of history, until the first decades of the twentieth century many of the most significant contemporary works of American history were produced by those who had had no formal training as historians."), _c('a', {
    attrs: {
      "id": "introductionfnote4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote4introduction"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same was certainly true in the field of American Jewish history. Amateur historians of American Jewry were, however, slow to develop a sustained interest in the Civil War. This changed in the 1880s and the 1890s with the publication of several articles and books that touched on the subject. These early efforts to interpret the Jewish experience of the war established the tone and approaches adopted almost uniformly until Korn broke the mold. This introduction traces the origin and evolution of these durable yet malleable tropes. What Jews wrote about the Civil War, we shall see, reveals much about their community’s position and "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("self-perception. What they omitted proves no less revealing, highlighting controversial and uncomfortable subjects thought best avoided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These works also expose the relationship between American Jewish historical writing and the American historiographic mainstream. Most accounts of Jewish participation were written under the influence of an “impartial” consensus view of the conflict that captured the center of the historical establishment in the 1890s. This consensus, presented most forcefully by John Ford Rhodes, Woodrow Wilson, William Dunning, and John Bach McMaster, reflected significant changes within the American historical profession: a postwar generational shift, a radical reevaluation of race and Reconstruction, and a drive for objectivity."), _c('a', {
    attrs: {
      "id": "introductionfnote5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote5introduction"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Those who sought the “nationalization of historical perspective”—the creation of a cohort of professional historians guided by the principles of objectivity and impartiality—eschewed what were perceived as the earlier partisan and sectional accounts of the conflict and its aftermath. In their stead, Rhodes, Wilson, Dunning, and McMaster offered a reconciliationist interpretation of the war that squared with both the political climate and the quest for objectivity within the profession. The consensus view that they created was rooted in a racist repudiation of Reconstruction and a relatively favorable reassessment of slavery and the Southern cause."), _c('a', {
    attrs: {
      "id": "introductionfnote6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote6introduction"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For much of the period between 1890s and the 1950s, Jewish representations of the war were closely tethered to these historiographical orthodoxies. Unlike the broader American historical field, however, Jewish historians steered clear of discussion of the period of Reconstruction, a major arena of debate and writing within the wider field. They were probably wary of addressing the stereotype of the Jewish carpetbagger and dealing with a period that offered more opportunities for controversy than contribution. It was also expedient (and easy) to steer clear of the subject of slavery, given the limited extent of Jewish slaveholding in the antebellum South and the sensitivity of this topic. Instead, accounts of the war provided opportunities to demonstrate the loyalty of American Jewry, to recount episodes of Jewish bravery, and to extol the contribution of Jews to the war effort. Beyond these goals, Jewish amateurs held limited ambitions as historians. Most did not seek to produce original research, interact with the wider historiography, court controversy, or challenge the mythology of the Jewish role in the conflict. In effect this meant that much Jewish historical writing was almost entirely disconnected from iconoclastic currents that rippled through American historiography between the 1890s and the 1950s. There is little evidence that the accounts written "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("by Jewish amateurs were influenced by the movement toward Progressive history, the revisionism initiated by the "), _c('em', [_vm._v("Journal of Negro History")]), _vm._v(", nor by the publication in 1935 of W. E. B. Du Bois’s epochal "), _c('em', [_vm._v("Black Reconstruction in America, 1860–1880")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "introductionfnote7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote7introduction"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The first book by a Jewish author to attempt a comprehensive examination of the Jewish involvement in the war was Isaac Markens’s "), _c('em', [_vm._v("The Hebrews in America")]), _vm._v(", published in 1888."), _c('a', {
    attrs: {
      "id": "introductionfnote8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote8introduction"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Markens assembled a collection of his newspaper articles into a chronicle celebrating Jewish success in America. His boosterism presented the rapidly expanding community as the obverse of its critics’ unfavorable descriptions. Yet Markens’s paean to progression and prosperity was laced with an implicit warning of the need for Jews to contribute conspicuously to broader American society."), _c('a', {
    attrs: {
      "id": "introductionfnote9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote9introduction"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" This same concern was evident in his representation of the Civil War. His listings of Jewish soldiers, interspersed with tales of heroism and sacrifice, highlighted Jewish loyalty and offered an ideal of Jewish-Christian fellowship. Here Markens echoed both the parochialism of pre-professional American historians and those arguing for a reconciliationist revision of wartime memory. In place of the North-South conciliation pushed by some professional historians, Markens offered an imagined idyll of Jewish-Christian comity. Although sketchily presented, Markens’s uncomplicated depiction contained some of the core elements of future representations, including the fact that he all but ignored Antisemitism and slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whereas Markens treated the Civil War in a perfunctory manner, skirting controversial issues, Katie Magnus’s "), _c('em', [_vm._v("Outlines of Jewish History")]), _vm._v(", reissued in 1890 by the Jewish Publication Society with new chapters on American Jewry written by Henrietta Szold and Cyrus Adler, avoided the conflict entirely. Markens had originally been approached to write the new section, but his contribution was judged unsatisfactory."), _c('a', {
    attrs: {
      "id": "introductionfnote10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote10introduction"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" However, his exultant and optimistic tone, but not his attention to a still divisive war, was reproduced in the new volume. Szold and Adler seem to have studiously avoided the subject, even as they did not demur from extolling Jewish loyalty and bravery in “furthering the patriotic cause” in the War of Independence and the War of 1812."), _c('a', {
    attrs: {
      "id": "introductionfnote11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote11introduction"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Their discussion of Michael Heilprin, a figure rarely described elsewhere without mention of his support for abolitionism, neglected this aspect of his biography. Perhaps the troubling dimensions of the war interfered with Szold and Adler’s buoyant presentation of American Jewish history. They discussed Antisemitism in America as an alien import—“legal rubbish, brought over from Europe” "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("that was “swept away forever” in the early nineteenth century—an interpretation that was incompatible with evidence of its surge during the Civil War period. Moreover, their focus on the themes of “unification, elevation and advancement,” and their presentation of Americans as a people “who have never failed to ignore speculative differences when the common good requires united action,” would have been difficult to reconcile with a recent fratricidal conflict. The apparent avoidance of the Civil War may be both an indication that the conflict remained contentious and that the ascendant reconciliationist interpretation had yet to diffuse into popular writing. With an uncertain legacy a decade after the retreat from Reconstruction—a decade that saw the incremental reinstitution of a racial caste system and blossoming adherence to the Lost Cause—the war may have been too controversial for inclusion in a textbook history that was both the first publication of the newly reconstituted Jewish Publication Society and intended for a broad audience. This was perhaps hinted at in the conclusion, where Szold and Adler argued that it was “not practicable to enter upon a discussion which will involve comparative values of current movements.”"), _c('a', {
    attrs: {
      "id": "introductionfnote12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote12introduction"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Simon Wolf, the B’nai B’rith’s representative in Washington, provided a dramatically different approach in "), _c('em', [_vm._v("The American Jew as Patriot, Soldier and Citizen")]), _vm._v(", published in 1895."), _c('a', {
    attrs: {
      "id": "introductionfnote13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote13introduction"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" Whereas Szold and Adler shied away from the conflict, Wolf embraced it. The book was an omnibus of articles and lists, running to over 550 pages, heralding the heroism and fidelity of American Jewry. It was intended to serve explicit political ends. Wolf’s effort was spurred by an angry exchange of letters in the "), _c('em', [_vm._v("North American Review")]), _vm._v(" in 1891."), _c('a', {
    attrs: {
      "id": "introductionfnote14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote14introduction"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" The controversial correspondence was initiated after Goldwin Smith, a respected historian and public figure, cited Judah Benjamin’s flight from the Confederacy as an illustration of how “the Jew changes their country more easily than others.”"), _c('a', {
    attrs: {
      "id": "introductionfnote15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote15introduction"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Isaac Bendavid wrote a lengthy rebuttal to this aspersion, describing Jewish Civil War service in detail."), _c('a', {
    attrs: {
      "id": "introductionfnote16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote16introduction"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" The December issue contained a response to Bendavid entitled “Jewish Soldiers in the Union Army,” written by a veteran who claimed not to")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("remember meeting one Jew in uniform, or hearing of any Jewish soldier. … [Nor had I met] any who remembered serving with Jews. I learned of no place where they stood, shoulder to shoulder, except in General Sherman’s department, and he promptly ordered them out for speculating in cotton and carrying information to the Confederates."), _c('a', {
    attrs: {
      "id": "introductionfnote17"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote17introduction"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("The letter “attracted unusual attention,” feeding into a current of nativism and Antisemitism that targeted Jews as an unwelcome and inassimilable group. It was “widely quoted and commented on by the newspaper press,” attaining, to Wolf’s mind, “a degree of publicity out of all proportion to its merits or its authorship.”"), _c('a', {
    attrs: {
      "id": "introductionfnote18"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote18introduction"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Wolf set out to provide evidence to counter these charges of Jewish clannishness and disloyalty. While centering his account on the Civil War, he offered evidence that in “free America” Jews had “stood from the very beginning ‘shoulder to shoulder’ with their fellow citizens of every creed, in every movement that has made for freedom and for liberty, for culture and charity.”"), _c('a', {
    attrs: {
      "id": "introductionfnote19"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote19introduction"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Wolf provided his readers with a pantheon of Jewish bravery—battalions of stiff-backed Jewish heroes intended to replace the ghetto-bent refugee in the popular imagination. He solicited support for these claims from officers “entirely non-Jewish in their origin.” Moreover, according to Wolf, these heroic Jews were distinctly Jewish, their “keen and responsive sense of duty” rooted in “Torah and Talmud.” Implicitly Wolf was defending the community against an indirect attack on Jewish immigration from Eastern Europe, arguing that new immigrants would rapidly become loyal American citizens, as they were but a part of a “history of the Jewish people” that was “one long tragedy of personal sacrifice and heroism.” Wolf felt confident in concluding that the “proportion of Jewish soldiers is, therefore, [not] only large, but is perhaps larger than that of any other faith in the United States.”"), _c('a', {
    attrs: {
      "id": "introductionfnote20"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote20introduction"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wolf’s polemic reflected and was aided by broader shifts in thinking about the war. The new representations of the conflict by Rhodes and his peers emphasized the themes of reconciliation, shared sacrifice, and common cause. Echoing the dominant political discourse, many American historians were starting to present the conflict less as a war between the states than as a struggle to build a new nation."), _c('a', {
    attrs: {
      "id": "introductionfnote21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote21introduction"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" This nationalist reappraisal of the conflict was evident in Wolf’s approach. He wrote of the war as a “struggle which has ended so beneficently as to have brought prosperity to both antagonists and dispelled the cause of discord.”"), _c('a', {
    attrs: {
      "id": "introductionfnote22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote22introduction"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" His work also reflected a related innovation drawn from these new interpretations of the conflict. Contemporary popular historians, led by Rhodes, sought to integrate Southern and Northern experience into a shared, nonpartisan national history."), _c('a', {
    attrs: {
      "id": "introductionfnote23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote23introduction"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" This trend served Wolf’s political and polemical purposes well, allowing him safely to point to Jewish service in both the armies of the North and South as evidence of Jewish loyalty and adaptability. The service of Southern Jews in the army of the Confederacy was proof that “while retaining his racial and religious distinctiveness, [the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Jew] identifies with the people among whom he dwells, if he is not deliberately excluded from doing so.”"), _c('a', {
    attrs: {
      "id": "introductionfnote24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote24introduction"
    }
  }, [_c('sup', [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The themes of service and loyalty that Wolf emphasized were echoed in many subsequent accounts. In 1896, Max Kohler, a New York lawyer and amateur historian, penned the revealingly titled “Incidents Illustrative of American Jewish Patriotism,” a catalogue of episodes “all tending to show that the Jew has ever been ready to battle for the cause of his adopted country.”"), _c('a', {
    attrs: {
      "id": "introductionfnote25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote25introduction"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" Tellingly, the Hebrew Union Veterans Organization (later the Jewish War Veterans of the United States) was established in the same year by Jewish veterans of the Civil War. The "), _c('em', [_vm._v("Jewish Encyclopedia")]), _vm._v(", published in the first years of the new century (and edited by Cyrus Adler, who had conspicuously ignored the war in his contribution to "), _c('em', [_vm._v("Outlines of Jewish History")]), _vm._v("), repeated Wolf’s claim that “the services rendered by the Jews to the states of their adoption or nativity have largely been in excess of their proportionate share.”"), _c('a', {
    attrs: {
      "id": "introductionfnote26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote26introduction"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" Later representations drew equally heavily on Wolf’s collection of often picaresque and romanticized stories, even while they sometimes sought to inflate his figures."), _c('a', {
    attrs: {
      "id": "introductionfnote27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote27introduction"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" While the pool of available anecdotes remained shallow, the attention given to this aspect of the war fluctuated substantially, resurfacing as an area of major interest in periods of crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The surge of broad popular interest in the Civil War at the turn of the century was reflected in the activities of the American Jewish Historical Society. Max Kohler, a mainstay of the organization and frequent contributor, wrote two trendsetting articles for its journal. The first examined the question of Jewish responses to slavery. Kohler recognized that this was a sensitive subject, particularly since the Civil War period was “barely past.” Despite his misgivings, he found reassurance in the “great activity in the writing of the Civil War and its chief actors” that he saw around him, surely evidence that")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("to-day we have reached a point from which we can view with intelligent appreciation and judgment the deeds of ’61, so that the mere fact that such treatises involve praise or blame for some still in our midst, should weigh but little against these other considerations, in the mind of the historian whose sole purpose is to set forth the truth."), _c('a', {
    attrs: {
      "id": "introductionfnote28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote28introduction"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kohler’s disclaimer mirrored the manifesto of the reconciliationist school of professionally trained historians who sought to reexamine the conflict objectively. Some of these historians, most notably Ulrich Bonnell "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Phillips, also offered a radical reassessment of slavery. The issue of slavery presented a serious obstacle to reimagining the war as a largely blameless conflict. By removing much of the stigma from slaveholding—presenting slavery as a benevolent institution and, when necessary, distinguishing individual owners from the institution, downplaying personal responsibility, and blaming structural factors—these historians shaped an inclusive and neutral new history of slavery. Abolitionism was a victim of this new reconciliatory interpretation, accused of fomenting fanaticism and friction between North and South."), _c('a', {
    attrs: {
      "id": "introductionfnote29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote29introduction"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" Kohler’s article reflected both the problems and opportunities that this shift presented for Jewish historians. The new approach made it possible for Kohler to present a thorough examination of Southern Jewish slaveholding. During the war, antisemites lashed the Northern Jewish community with evidence of Judah P. Benjamin’s and other Southern Jews’ ownership of slaves."), _c('a', {
    attrs: {
      "id": "introductionfnote30"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote30introduction"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" Ironically, instead of engendering embarrassment, an honest appraisal now proffered political advantages. It provided further demonstration of Jewish adaptability and regional loyalty. Kohler argued that Jewish slaveholding demonstrated that Jews were “receptive and assimilative” to their environment, not the clannish and inassimilable outsiders of hostile depiction. They were “as actively identified with the institution as any other class of settlers.”"), _c('a', {
    attrs: {
      "id": "introductionfnote31"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote31introduction"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, Kohler’s primary focus, and sympathies, lay with opponents of slavery. While he lambasted the “revolutionary and impractical or anarchistic ravings of certain abolitionist leaders,” his tone was inflected with obvious admiration for Jewish supporters of abolitionism. David Einhorn’s “uncompromising, rigorous, earnest and convincing” stand against slavery, and his subsequent flight from Baltimore, was contrasted favorably with Morris Raphall’s defense of slavery on biblical grounds."), _c('a', {
    attrs: {
      "id": "introductionfnote32"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote32introduction"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" Kohler proudly claimed that Judaism “contributed its share to the awakening and development of these moral forces and sentiments” and pointed to “numerous influences at work among the Jews of the United States in favor of the abolition movement.” Yet he positioned the bulk of the community on unassailable high ground: “antagonism or aloofness on the part of many American Jews to or from anti-slavery agitation was due to love for the Union, and fear of its disruption, to which the Abolitionist propaganda at one time threatened to lead, rather than to any sympathy for slavery.”"), _c('a', {
    attrs: {
      "id": "introductionfnote33"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote33introduction"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v("Kohler’s pioneering work in this area encouraged little further exploration. Instead, for almost half a century, his work on slavery seemed to mark a historical cul-de-sac. Later works of popular Jewish history remained largely reticent on the causes of the war. This mirrored a trend "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("within the mainstream literature on the conflict into the 1930s, which tended to focus more closely on Reconstruction. When slavery was discussed, it was primarily to demonstrate Jewish sympathy for abolition or the sectional loyalty of Southern Jews or to recount David Einhorn’s flight from Baltimore."), _c('a', {
    attrs: {
      "id": "introductionfnote34"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote34introduction"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" The subject was only substantially revisited in the 1940s, when a new political imperative demanded a reassessment of the lessons of slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kohler’s second groundbreaking article had a more sustained impact. Kohler set out single-handedly to resurrect the standing of Judah P. Benjamin as the “most distinguished statesman, orator and lawyer, that American Jewry has produced.”"), _c('a', {
    attrs: {
      "id": "introductionfnote35"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote35introduction"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" As with slavery, it had become acceptable, and even politically expedient, to reconsider a sensitive subject. Benjamin’s wartime conduct had come under attack in a number of memoirs, including the widely read "), _c('em', [_vm._v("The End of an Era")]), _vm._v(", published in 1899. The book described Benjamin as")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("oleaginous, … his keg-like form and over-deferential manner suggestive of a shopkeeper. But his eye redeemed him and his speech was elegantly polished, even if his nose was hooked and his lips shone red amidst the curly black of his semitic beard. … [He had] more brains and less heart than any other civic leader in the South. He was an English Jew and a lawyer of the first rank. … If his client was in any case hanged … likely as not, he would be having a bottle of Madeira and a cigar at his club the moment the hanging was taking place. … When a case was lost, he did not bemoan it; he found another. … The Confederacy and its collapse were no more to Judah P. Benjamin than last year’s birds nest."), _c('a', {
    attrs: {
      "id": "introductionfnote36"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote36introduction"
    }
  }, [_c('sup', [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In spite, and probably because of, Benjamin’s ambivalent position in both Confederate and American Jewish history, Kohler launched a defense of his reputation as a politician and as a Jew. Kohler paid little attention to Benjamin’s term as secretary of war—service that earned him censure from the Confederate Congress and the enmity of Southerners and Northerners—instead focusing on his less controversial tenure in the Senate, term as secretary of state for the Confederacy, and postwar career in England. While Kohler was intent on restoring Benjamin’s tarnished image, he also sought to reclaim him as a Jew. This was an equally difficult task. Benjamin had intermarried and evinced negligible interest in the Jewish community. Undeterred, Kohler assembled a litany of mostly apocryphal episodes to demonstrate that Benjamin was a closet Jew by "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("convenience and not conviction. These examples entered Benjamin lore, an oft-repeated mythology that remained unchallenged until the late 1940s: a Hebrew psalter at Yale, Isaac Mayer Wise’s account of a theological discussion, and a riposte, also attributed to Disraeli, to an antisemitic remark."), _c('a', {
    attrs: {
      "id": "introductionfnote37"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote37introduction"
    }
  }, [_c('sup', [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Kohler conceded that Benjamin was “little more than a race Jew,” he did find evidence of the “influence of Jewish antecedents and traits in moulding his career.”"), _c('a', {
    attrs: {
      "id": "introductionfnote38"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote38introduction"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" Implicitly, one of these traits was intelligence. Kohler reinterpreted what was originally intended as a critical comment—that Benjamin was the cold and manipulating “brains of the confederacy”—into a statement celebrating a valorized Jewish attribute. Kohler expanded on this theme in his entry on Benjamin in the "), _c('em', [_vm._v("Jewish Encyclopedia")]), _vm._v(". He cited Benjamin’s London "), _c('em', [_vm._v("Times")]), _vm._v(" obituary as affirmation from an authoritative non-Jewish source of this claim of positive innate Jewishness:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("His inheritance of that elastic resistance to evil fortune which preserved Mr. Benjamin’s ancestors through a succession of exiles and plunderings, and reappeared in the Minister of the Confederate cause, together with the same refined apprehension of logical problems which informed the subtleties of the Talmud."), _c('a', {
    attrs: {
      "id": "introductionfnote39"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote39introduction"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kohler thus transformed Benjamin into a communal hero:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Benjamin’s attitude did not represent that of a majority of his race, but fortunately, time has healed old wounds. We can do justice to-day to the views of the leaders of that differed from the prevailing policy, and instead of being ashamed to be identified with Benjamin, American Jewry can to-day point with pride to the remarkable career of the greatest statesman, orator and lawyer it has yet produced, notwithstanding his identification with the “Lost Cause.”"), _c('a', {
    attrs: {
      "id": "introductionfnote40"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote40introduction"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Subsequent accounts of the Jewish involvement in the Civil War gave Judah P. Benjamin pride of place, drawing heavily on, and often parroting, Kohler’s depiction."), _c('a', {
    attrs: {
      "id": "introductionfnote41"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote41introduction"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" However, Benjamin was forced to share the limelight with his nemesis, Abraham Lincoln. In an article read to the American Jewish Historical Society on Lincoln’s birthday in 1904, Myer Isaacs laid the foundations for a fourth dominant theme, adding to those introduced by Wolf and Kohler. While Isaacs wrote about the chaplaincy "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("controversy—the efforts of the Northern Jewish community to alter a congressional statute that stipulated that army chaplains be of a “Christian denomination”—the conceptual framework that he applied, alongside the subject itself, became a staple of later Jewish representations of the war. Isaacs’s impact came from the formula he provided for understanding this and other troubling dimensions of the conflict. For Isaacs, the episode served primarily as a reminder of the “momentous events in which the great Lincoln was the principal figure, as typical of the American who loved his country and was near to the ‘common people.’”"), _c('a', {
    attrs: {
      "id": "introductionfnote42"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote42introduction"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" Isaacs was producing a Jewish version of the cult of Lincoln, casting “Father Abraham” as the central character of Jewish Civil War experience."), _c('a', {
    attrs: {
      "id": "introductionfnote43"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote43introduction"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" He warned that")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("profane hands, even now, touch the ark which holds sacred the memory of the beloved and martyred President. We of the Jewish Historical Society reverently place our tribute of gratitude by the side of the myriad chaplets in honor of the American who was too great to be sectarian, whose motto was “Malice toward none—charity for all,” “doing the right as God gave him to see the right,” whose idea of atonement was the Jewish inspiration, “let the oppressed go free.”"), _c('a', {
    attrs: {
      "id": "introductionfnote44"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote44introduction"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although Jewish idolization of Lincoln was not in itself new, the novelty came from the way in which Isaacs refracted the chaplaincy controversy through the Lincoln lens. Isaacs introduced a tendency for episodes of wartime Antisemitism—for example, Grant’s General Order No. 11 that had expelled the “Jews, as a class” from the Department of Tennessee—to be portrayed less as crises of acceptance and integration than as vehicles for demonstrating Jewish links with Lincoln."), _c('a', {
    attrs: {
      "id": "introductionfnote45"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote45introduction"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" This focus on Lincoln meant that wartime Antisemitism was decontextualized, treated as an episodic and isolated phenomenon. If anything, attention to a limited number of antisemitic incidents served primarily to embellish the Jewish Lincoln mythology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isaac Markens’s article “Lincoln and the Jews,” published in 1909 to mark the centenary year of Lincoln’s birth, reinforced this nascent Lincoln-centered representation of the war."), _c('a', {
    attrs: {
      "id": "introductionfnote46"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote46introduction"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" Markens offered a catalogue of “touching” stories, revealing the mutual regard shared by Lincoln and his Jewish citizens, as well as the president’s personal interest in the community."), _c('a', {
    attrs: {
      "id": "introductionfnote47"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote47introduction"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" He also trumpeted the role of Jews in a glorified national history. According to Markens, it was a Jew, Edward Rosewater, who “with his own hands transmitted to the world from the telegraph office of the War "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Department in Washington Lincoln’s Emancipation Proclamation.”"), _c('a', {
    attrs: {
      "id": "introductionfnote48"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote48introduction"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" Lincoln entrusted Isachar Zacharie, his chiropodist, with the “role of peace-maker” in a mission to Richmond. With subsequent retelling, Zacharie became the most (and only?) celebrated chiropodist in Jewish history."), _c('a', {
    attrs: {
      "id": "introductionfnote49"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote49introduction"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v("Citing Isaac Mayer Wise, Markens even suggested that Lincoln himself may have been")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("one of the chosen people: “Abraham Lincoln believed himself to be bone of our bone and flesh of our flesh. He supposed himself to be of Hebrew parentage, "), _c('em', [_vm._v("he said so in my presence")]), _vm._v(", and indeed he possesses the common features of the Hebrew race both in countenance and features.”"), _c('a', {
    attrs: {
      "id": "introductionfnote50"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote50introduction"
    }
  }, [_c('sup', [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The community, by associating itself with the iconic and revered figure of Abraham Lincoln, could burnish its own image and self-perception. This theme reached its apogee in the publication of "), _c('em', [_vm._v("Abraham Lincoln: The Tribute of the Synagogue")]), _vm._v(" in 1927. Emanuel Hertz, a bibliophile and the brother of England’s chief rabbi, compiled a 682-page compendium of sermons, eulogies, and writings by rabbis and prominent communal leaders on Lincoln."), _c('a', {
    attrs: {
      "id": "introductionfnote51"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote51introduction"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" However unlikely the match, “Father Abraham,” an adopted patriarch, and Judah P. Benjamin, a reclaimed wayward son, dominated Jewish Civil War historical writing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These foundational tropes, introduced over the course of a decade, remained remarkably stable and durable into the 1950s, even as the broader historiography was roiled and gradually revised by the work of iconoclasts such as C. Vann Woodward and W. E. B. Du Bois. It was a formula that was repeated with little variation in children’s literature, school text books, and works of general American Jewish history into the 1950s. Max Raisin’s "), _c('em', [_vm._v("A History of the Jews in Modern Times")]), _vm._v(", published in 1923 and marketed as a companion volume to Graetz’s "), _c('em', [_vm._v("History of the Jews")]), _vm._v(", provides an example of the assimilation of these themes. America’s Jews had “rendered invaluable services in the Union as well as the Confederate armies” yet, “like their Christian fellow-citizens,” were “a house divided against itself on the question of slavery.” Some Southern Jews were “stanch believers in the slavery institution,” but “probably owing to their natural tenderness which has ever been the marked characteristic of the race, they treated their slaves with greater consideration than did the non-Jews.” By contrast, the Northern Jewish community produced some of the “greatest champions of the anti-slavery cause, … tireless in ["), _c('em', [_vm._v("sic")]), _vm._v("] behalf of the emancipation movement.” Lincoln counted “numerous personal friends "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("among the Jews.” So did the Confederate president: at the “right hand of President Jefferson Davis, sat a Jew to whom was attributed the distinction of being the ‘brains of the Confederacy,’” a man “almost fanatical in his Southern patriotism, … who never for a moment lost the confidence of the President who, more than upon any other member of his official family, leaned upon him in all the weightiest of problems.”"), _c('a', {
    attrs: {
      "id": "introductionfnote52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote52introduction"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" Northern and Southern Antisemitism was barely mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Simon Glazer’s "), _c('em', [_vm._v("History of Israel")]), _vm._v(" (1930), another attempt to capitalize on the success of “Graetz-Dubnow,” provided a similar summary but paid less attention to the already unreliable facts."), _c('a', {
    attrs: {
      "id": "introductionfnote53"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote53introduction"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Max Margolis and Alexander Marx’s "), _c('em', [_vm._v("A History of the Jewish People")]), _vm._v(" (1927), Paul Masserman and Max Baker’s "), _c('em', [_vm._v("The Jews Come to America")]), _vm._v(" (1932), Ismar Elbogen’s "), _c('em', [_vm._v("A Century of Jewish Life")]), _vm._v(" (1944), Solomon Grayzel’s "), _c('em', [_vm._v("A History of the Jews")]), _vm._v(" (1947), and Anita Lebeson’s grandiloquent epic "), _c('em', [_vm._v("Pilgrim People")]), _vm._v(" (1950) also followed this general pattern in describing the war."), _c('a', {
    attrs: {
      "id": "introductionfnote54"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote54introduction"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" Philosemite Samuel Walker McCall, a former governor of Massachusetts, wrote "), _c('em', [_vm._v("Patriotism of American Jewry")]), _vm._v(" (posthumously published in 1924), which repeated these same entrenched themes in discussing Jewish war service. The book was intended as a response to those who, clamoring to close America’s doors to Jewish immigrants, argued “that the Jew can be true to no country and is lacking in the capacity for patriotism.”"), _c('a', {
    attrs: {
      "id": "introductionfnote55"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote55introduction"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" Charles Eliot, former president of Harvard University, added his voice to McCall’s opposition to the imposition of immigration quotas, although his endorsement came with reservations."), _c('a', {
    attrs: {
      "id": "introductionfnote56"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote56introduction"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These themes were most strongly expressed in literature intended for younger audiences. Lee Levinger’s high school textbook "), _c('em', [_vm._v("A History of the Jews in the United States")]), _vm._v(", issued in 1930, used the same material for instructional purposes."), _c('a', {
    attrs: {
      "id": "introductionfnote57"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote57introduction"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" Subsections in the chapter on the Civil War included “The Sympathies of the Jews” (three pages), “Abraham Lincoln and the Jews” (four pages), “Jews in the Armies” (three pages), and “Judah P. Benjamin” (five pages)."), _c('a', {
    attrs: {
      "id": "introductionfnote58"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote58introduction"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" Special note was taken of Benjamin’s work habits and chivalrous demeanor."), _c('a', {
    attrs: {
      "id": "introductionfnote59"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote59introduction"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" While praised as a proud Jew—“quick to resent an insult, whether against him or his people”—he and Benjamin Disraeli were gently rebuked for thinking “more of the achievements of their ancestors than they did of serving their people.”"), _c('a', {
    attrs: {
      "id": "introductionfnote60"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote60introduction"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" Oscar Leonard’s "), _c('em', [_vm._v("Americans All: Grandfather Tells Benny How Jews Helped in the Discovery and Building of America")]), _vm._v(", published in 1945, placed a wartime spin on Lincoln and Benjamin."), _c('a', {
    attrs: {
      "id": "introductionfnote61"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote61introduction"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" Franklin Roosevelt was portrayed as the latter-day Lincoln, “not only "), _c('em', [_vm._v("our")]), _vm._v(" champion of liberty—he’s a symbol for the whole world, "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("bringing light and new hope to the enslaved nations.” Lincoln’s lessons of tolerance and “true humanity lives for us today. We have a big fight on our hands—and it’s good to remember Lincoln and what he stood for.”"), _c('a', {
    attrs: {
      "id": "introductionfnote62"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote62introduction"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v("The chapter “They Were Friends of Lincoln” was followed by the story of the “Brains of the Confederacy.” Benjamin was introduced as a Moses-like figure, the allusion crystallized in an illustration of a stylized Benjamin, drawn to look like Lincoln, seizing the whip hand of an overseer about to lash a kneeling slave."), _c('a', {
    attrs: {
      "id": "introductionfnote63"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote63introduction"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The attention lavished on Benjamin suggests that he was particularly useful as an aspirational and inspirational role model, success story, and figure of pride at a time of increasing Antisemitism and reduced opportunity. His was a malleable Jewish tale, even reconfigured into an immigration story—arriving old and penniless in Britain after his flight from the defeated Confederacy and regaining prominence, acceptance, and wealth."), _c('a', {
    attrs: {
      "id": "introductionfnote64"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote64introduction"
    }
  }, [_c('sup', [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("World War II and its uncertain aftermath also generated a barrage of historical writing by Jewish veterans. These volumes reproduced the traditional Jewish Civil War narrative. Sydney Gumpertz, winner of the Congressional Medal of Honor in World War I, offered a blood-soaked portrait of Jewish involvement in the Civil War—a “whole people of the same blood struggling to the death in the defense of ideals”—in his "), _c('em', [_vm._v("Jewish Legion of Valor")]), _vm._v(". Above all, he stressed that Judaism was Americanism: “Deep rooted in the heart of the American Jew lies a spirit that is the American creed and he again drew his sword for an ideal that was his ideal, a creed that was his creed.”"), _c('a', {
    attrs: {
      "id": "introductionfnote65"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote65introduction"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" As with Wolf before him, Gumpertz treated the cause of the Confederacy and Union as equally worthy of Jewish sacrifice and service."), _c('a', {
    attrs: {
      "id": "introductionfnote66"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote66introduction"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" While the substance of these representations of the Civil War remained largely unchanged, the threat that these books were intended to address did change. For example, J. George Fredman and Louis Falk’s "), _c('em', [_vm._v("Jews in American Wars")]), _vm._v(", a volume that was reprinted four times during World War II, recounted Jewish involvement in the Civil War in order to combat the “moral havoc wrought by the weapon of [Nazi] propaganda.”"), _c('a', {
    attrs: {
      "id": "introductionfnote67"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote67introduction"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" A new edition, published in 1954, had an altered agenda, urging its readers to recognize the “treasonous ideology of Communism and to take steps to arouse the nation to combat it.” A substantial amount of new material was added to the Civil War section, including, on the Confederate side, the claim that “a Jew fired the first gun against Fort Sumter, and another gave the last shelter to the fleeing President and Cabinet of the falling Confederacy.”"), _c('a', {
    attrs: {
      "id": "introductionfnote68"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote68introduction"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" As the centenary approached, more and more the Civil War had become a Jewish war.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("This stylized depiction of Judah P. Benjamin seizing the hand of an overseer about to whip a kneeling slave is emblematic of the rehabilitation of Judah P. Benjamin in American Jewish popular memory. During and after the war Benjamin became the focus of antisemitic venom. From the beginning of the twentieth century, Jewish historians sought to reclaim Benjamin as a Jewish hero. This illustration, which appeared in a children’s book in 1945, recast Benjamin as a Moses-like figure. © Behrman House., Inc., reprinted with permission "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.behrmanhouse.com",
      "target": "_blank"
    }
  }, [_vm._v("www.behrmanhouse.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("While World War II appeared to reinforce the traditional Jewish approach to representing the Civil War, it also inspired a radically different assessment of the subject. For the first half of the century, Jewish Civil War historiography had been insulated from the revisionist currents that challenged the dominant nationalist interpretation of the war. It remained a field of enthusiasts and amateurs. Now for the first time a professionally trained historian reexamined Jewish involvement in the conflict. Philip Foner, a labor historian fired from the City College of New York in 1941 for membership in the Communist Party, published a short popular volume entitled "), _c('em', [_vm._v("The Jews in American History")]), _vm._v(" in 1945."), _c('a', {
    attrs: {
      "id": "introductionfnote69"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote69introduction"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" Nearly half the book was devoted to the Civil War, drawing on a substantial amount of new research. Foner’s reinterpretation of the war bore the hallmarks of the revisionist approach to slaveholding and Reconstruction pioneered by W. E. B. Du Bois, and it echoed the progressive racial agenda of fellow Communist historians Herbert Aptheker and James Allen. While Foner repeated some staple elements of the Jewish mythology of the conflict, he centered his account on the iniquities of slavery. The Jewish role was measured according to its commitment and contribution to the antislavery cause. Foner’s second innovation was to give substantial attention to the role of Jewish women in the abolitionist movement and on the home front."), _c('a', {
    attrs: {
      "id": "introductionfnote70"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote70introduction"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" By contrast, Southern Jewry and Judah P. Benjamin received brief and unfavorable treatment. Foner’s representation of Abraham Lincoln did not vary from the traditional approach."), _c('a', {
    attrs: {
      "id": "introductionfnote71"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote71introduction"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v("For all its innovation, the work was tendentious. Foner’s message was of the necessity of Jewish steadfastness and sacrifice for a progressive cause. However, unlike the conservative priorities of the contemporaneous accounts produced by veterans, Foner’s preferred cause was suggested in his approving references to Jewish activists who “did not flinch before the ‘red baiters’ of the 1850s.”"), _c('a', {
    attrs: {
      "id": "introductionfnote72"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote72introduction"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Foner was substituting one polemical reading of the war for another. His history concluded with an implicit cri de coeur for Jews to support the struggle for black civil rights in the United States once World War II ended. Referring as much to the present as to the past, he wrote that the")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Civil War was over but the battle for the full freedom of the Negro people in America was just beginning. It was to be expected that the Jewish people would participate in this struggle. For as Rabbi Bernhard Felsenthal pointed out, any discrimination against the Negro people affected the status of Jews in America, since it was impossible to deny one minority its full rights without injuring the rights of all minorities. … Freedom for one minority would bring increased freedom for others."), _c('a', {
    attrs: {
      "id": "introductionfnote73"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote73introduction"
    }
  }, [_c('sup', [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Although a forerunner of later academic treatments of the subject, Foner’s work was significant foremost as a first break with the filiopietism and amateurism of the past, rather than as a predictor of the directions in which this new Jewish Civil War history would move."), _c('a', {
    attrs: {
      "id": "introductionfnote74"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote74introduction"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" Bertram Korn and, to a lesser extent, Morris Schappes and Jacob Rader Marcus were the pioneers of this new history. Their work paralleled a broader revisionist reappraisal of the Civil War that had begun in the 1930s, particularly the work of historians interested in the nativism and racism that the war spurred."), _c('a', {
    attrs: {
      "id": "introductionfnote75"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote75introduction"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Korn’s myth-deflating article on Judah P. Benjamin, followed by his groundbreaking book "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(", the first full-scale academic treatment of the subject, reshaped the historical representation of Jewish involvement in the conflict."), _c('a', {
    attrs: {
      "id": "introductionfnote76"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote76introduction"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" His account shed the romanticism of his predecessors, carefully analyzing Northern and Southern Antisemitism, thoroughly investigating Jewish attitudes toward slavery and abolition, and perhaps most heretically of all, contending that “"), _c('em', [_vm._v("Benjamin had no positive or active interest in Jews or Judaism")]), _vm._v(".”"), _c('a', {
    attrs: {
      "id": "introductionfnote77"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote77introduction"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" Korn’s work replaced Wolf’s, Kohler’s, and Isaacs’s as the benchmark study of Jews and the Civil War. His depiction was popularized as the tercentenary of Jewish settlement in America, followed by the centenary of the war itself, generated a boom in interest in the Civil War. A substantial museum exhibition, relying heavily on his research, was mounted to memorialize the conflict. The centennial also spurred other Jewish historians to reexamine the war."), _c('a', {
    attrs: {
      "id": "introductionfnote78"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote78introduction"
    }
  }, [_c('sup', [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In spite of the professionalization of the writing of American Jewish history, earlier themes were difficult to uproot from Jewish popular memory, particularly as some of these themes again became politically useful in the 1960s. The centenary of the Civil War coincided with a period when Jewish loyalties in the South were once more disputed. In Alabama, the State B’nai B’rith deployed Judah P. Benjamin—a Louisianan—to fight its cause. The organization devoted a session of its annual convention in 1962 to the “commemoration of the Jewish contribution to the War between the States.” The event featured Jefferson Davis biographer Hudson Strode speaking on “Jefferson Davis and His Jewish Confederates.”"), _c('a', {
    attrs: {
      "id": "introductionfnote79"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote79introduction"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" The "), _c('em', [_vm._v("Huntsville Times")]), _vm._v(" reported that the convention would “kick off with a Banquet and Dance Saturday night, with the theme, ‘Judah P. Benjamin Nite.’”"), _c('a', {
    attrs: {
      "id": "introductionfnote80"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote80introduction"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" J. S. Gallinger, the State B’nai B’rith president, entitled his annual report “The Covenant Confederacy Annual Convention.” More significant than the pageantry was the decision to sponsor the erection of a monument at the capitol in Alabama in honor of the “merits of Judah P. Benjamin, as a son of the Jewish people.”"), _c('a', {
    attrs: {
      "id": "introductionfnote81"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#fnote81introduction"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" A century after the end of the war, a malleable past was still being marched out in defense of the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Although the revanchist memory embraced by the Alabama B’nai B’rith contrasted sharply with the mainstream of the historical profession in the 1960s—typified by the new work on slavery and the Civil War produced by C. Vann Woodward, Kenneth Stampp, and Eugene Genovese—this instance of Southern Jewish manipulation of memory to serve political purposes was in step with a century of past practice. The amateur historians—Wolf, Kohler, and Isaacs—who entrenched the themes that dominated Jewish representation of the Civil War for the first half of the twentieth century, as well as some of the first professional historians who challenged these motifs—Foner and Schappes—were responding to political imperatives. In each case, their representations were facilitated and legitimized by developments within the broader historiography of the Civil War. Jewish historical writing about the war evolved slowly alongside this general historiography, assimilating themes and approaches that could be used to bolster the image of the Jewish community or, in the case of Philip Foner, to impel it into action. For the most part, this was a self-serving use of history. The key elements of the dominant depiction of the war—loyal Jewish service to both North and South, the reciprocated Jewish love of Lincoln, and the braininess of Benjamin—echoed the reconciliatory spirit of the broader historiography in the early decades of the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jewish historical writing hardly strayed from this nationalist interpretation offered in popular form by Rhodes and his professional colleagues from the 1890s, foremost because this account was convenient. This attachment to the conservative mainstream of American historiography facilitated a politically expedient Jewish reading of the war. It allowed a superficial discussion of Southern Jewish slaveholding that avoided troubling questions about morality and responsibility and enabled the resurrection of Judah P. Benjamin as a communal hero. Moreover, it allowed amateur historians, keen to extol Jewish patriotism and bravery, to present both Northern and Southern Jews as heroes. As the Alabaman example suggests, once adopted, these politically useful depictions have been difficult to displace, even when challenged by changes in mainstream historical thinking. Some Jewish historians continue to prefer the blameless war of Rhodes, Wilson, Dunning, and McMaster to the altogether more complicated and troubling version offered by Du Bois, Woodson, Woodward, and their historical heirs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Although Korn’s "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(" failed to uproot completely misperceptions and myths from collective memory and popular "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("history, his work planted the seeds for a new era of serious scholarship. The essays included in this volume represent the best of this literature. Almost all bear his imprint. Although these and other authors (whose work is detailed in “For Further Reading”) have discovered new sources, offered fresh perspectives, and added considerable nuance—enriching our understanding of rabbinic attitudes, revealing the challenges facing women on the home front, and contextualizing Grant’s Order No. 11—for the most part scholarship has not strayed far from the questions Korn originally raised. Historians have supplemented rather than revised his themes and conclusions. (His understanding of the Jewish relationship with abolitionism is one important exception.) As a result, several areas that received little attention in "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(" remain underexplored. Korn, perhaps wary of military history, paid strikingly little attention to Jewish soldiering during the war. Likewise, we are still largely ignorant of the impact of the conflict on Jewish civilians caught in the destructive war zone, and equally so about the experience for Jews in Northern cities roiled by social and political tension. Aside from the canard of the Jewish carpet-bagger, we know little about Jews and Reconstruction. Nonetheless, in the half century since the last major anniversary of the Civil War, professional historians have almost uniformly abandoned the parochial and politically expedient approaches that characterized writing about Jews and the Civil War in the decades before 1950. As we approach the sesquicentennial of the conflict, we await a fresh synthesis by a new generation of historians.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote1introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote1"
    }
  }, [_vm._v("1")]), _vm._v(". Bertram W. Korn, "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(" (Philadelphia, 1951).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote2introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote2"
    }
  }, [_vm._v("2")]), _vm._v(". This essay draws on and revises my article “‘A Struggle Which Ended So Beneficently’: A Century of Jewish Historical Writing about the American Civil War,” "), _c('em', [_vm._v("American Jewish History")]), _vm._v(" 92:4 (December 2007): 438–454.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote3introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote3"
    }
  }, [_vm._v("3")]), _vm._v(". For the historiography of the war, see Thomas Pressley, "), _c('em', [_vm._v("Americans Interpret Their Civil War")]), _vm._v(" (Princeton, NJ, 1954); David Blight, "), _c('em', [_vm._v("Race and Reunion: The Civil War in American Memory")]), _vm._v(" (Cambridge, MA, 2001); David Blight, "), _c('em', [_vm._v("Beyond the Battlefield: Race, Memory, and the American Civil War")]), _vm._v(" (Boston, 2002); Paul Shackel, "), _c('em', [_vm._v("Memory in Black and White: Race, Commemoration, and the Post-Bellum Landscape")]), _vm._v(" (Walnut Creek, CA, 2003); Hugh Tulloch, "), _c('em', [_vm._v("The Debate on the American Civil War Era")]), _vm._v(" (Manchester, UK, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote4introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote4"
    }
  }, [_vm._v("4")]), _vm._v(". Peter Novick, "), _c('em', [_vm._v("That Noble Dream: The “Objectivity” Question and the American Historical Profession")]), _vm._v(" (Cambridge, UK, 1999), 49–50.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "fnote5introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote5"
    }
  }, [_vm._v("5")]), _vm._v(". John Ford Rhodes, "), _c('em', [_vm._v("History of the United States from the Compromise of 1850")]), _vm._v(" (New York, 1892); Woodrow Wilson, "), _c('em', [_vm._v("Division and Reunion, 1829–1889")]), _vm._v(" (New York, 1893); William Dunning, "), _c('em', [_vm._v("Essays on the Civil War and Reconstruction and Related Topics")]), _vm._v(" (New York, 1897); John Bach McMaster, "), _c('em', [_vm._v("History of the People of the United States: From the Revolution to the Civil War")]), _vm._v(" (New York, 1883–1913).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote6introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote6"
    }
  }, [_vm._v("6")]), _vm._v(". See Novick, "), _c('em', [_vm._v("That Noble Dream")]), _vm._v(", 72–80.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote7introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote7"
    }
  }, [_vm._v("7")]), _vm._v(". W. E. B. Du Bois, "), _c('em', [_vm._v("Black Reconstruction in America, 1860–1880")]), _vm._v(" (New York, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote8introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote8"
    }
  }, [_vm._v("8")]), _vm._v(". Isaac Markens, "), _c('em', [_vm._v("The Hebrews in America: A Series of Historical and Biographical Sketches")]), _vm._v(" (New York, 1888).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote9introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote9"
    }
  }, [_vm._v("9")]), _vm._v(". While Jews had “made themselves felt throughout the land to an extent far greater than any like number of people … [and] are recognized as among the most useful of our citizens,” they had to remain “enterprising and foremost in all public movements looking to the welfare of the entire people, patriotic and law abiding, cosmopolitan in their charities, and permitting none of their people to become a burden on the State or city, [so that] their presence is welcomed and their power is extending year after year.” Ibid., v. See also ibid., 126–138, 177–179.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote10introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote10"
    }
  }, [_vm._v("10")]), _vm._v(". See Jonathan Sarna, "), _c('em', [_vm._v("JPS: The Americanization of Jewish Culture, 1888–1988")]), _vm._v(" (Philadelphia, 1989), 29–33.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote11introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote11"
    }
  }, [_vm._v("11")]), _vm._v(". “All these good officers were treasured by the people at large, and the time was soon to come when it was well that the Jews had a fair reputation for patriotism set to their credit in the historical ledger of the American nation.” Katie Magnus, "), _c('em', [_vm._v("Outlines of Jewish History")]), _vm._v(" (Philadelphia, 1890), 348–350.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote12introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote12"
    }
  }, [_vm._v("12")]), _vm._v(". The war was neglected in later editions of the book. Ibid., 352, 366–367.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote13introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote13"
    }
  }, [_vm._v("13")]), _vm._v(". Simon Wolf, "), _c('em', [_vm._v("The American Jew as Patriot, Soldier and Citizen")]), _vm._v(" (Philadelphia, 1895).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote14introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote14"
    }
  }, [_vm._v("14")]), _vm._v(". The exchange is discussed at length in Sylvan Morris Dubow, “Identifying the Jewish Servicemen in the Civil War: A Re-appraisal of Simon Wolf’s "), _c('em', [_vm._v("The American Jew as Patriot, Soldier and Citizen")]), _vm._v(",” "), _c('em', [_vm._v("American Jewish Historical Quarterly")]), _vm._v(" 59 (1969): 357–369. See also Esther Panitz, "), _c('em', [_vm._v("Simon Wolf: Private Conscience and Public Image")]), _vm._v(" (Cranbury, NJ, 1987), 178–179.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote15introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote15"
    }
  }, [_vm._v("15")]), _vm._v(". Goldwin Smith, “New Light on the Jewish Question,” "), _c('em', [_vm._v("North American Review")]), _vm._v(" 153:2 (1891): 129–143. On Goldwin Smith, see Gerald Tulchinsky, “Goldwin Smith: Victorian Canadian Antisemite,” in Richard Menkis and Norman Ravvin, eds., "), _c('em', [_vm._v("The Canadian Jewish Studies Reader")]), _vm._v(" (Markham, ON, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote16introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote16"
    }
  }, [_vm._v("16")]), _vm._v(". Isaac Bendavid, “Goldwin Smith and the Jews,” "), _c('em', [_vm._v("North American Review")]), _vm._v(" 153:3 (1891): 257–271.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote17introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote17"
    }
  }, [_vm._v("17")]), _vm._v(". J. M. Rogers, “Jewish Soldiers in the Union Army,” "), _c('em', [_vm._v("North American Review")]), _vm._v(" 153:6 (1891): 761–762.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote18introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote18"
    }
  }, [_vm._v("18")]), _vm._v(". Wolf, "), _c('em', [_vm._v("American Jew as Patriot, Soldier and Citizen")]), _vm._v(", 2–3, 544–564. Mark Twain repeated this claim in his article “Concerning the Jews” in "), _c('em', [_vm._v("Harper’s Magazine")]), _vm._v(" in March 1898: “He [the Jew] is a frequent and faithful and capable officer "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("in the civil service, but he is charged with an unpatriotic disinclination to stand by the flag as a soldier.” Later, based on Wolf, he published an addendum with a correction.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote19introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote19"
    }
  }, [_vm._v("19")]), _vm._v(". Ibid., 566. His purpose, according to his collaborator Louis Levy, was to “combat one of the most obstinate of all obstinate prejudices. … His impelling motive has been to enforce a recognition of the Jewish people as a militant force in the upbuilding of the State, and of Judaism as a primal force in the furtherance of civilization.” Ibid., vii.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote20introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote20"
    }
  }, [_vm._v("20")]), _vm._v(". Ibid., 6. Wolf even suggested that a single mysterious Jew had single-handedly preserved the nation by halting British intervention. Ibid., 87–89.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote21introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote21"
    }
  }, [_vm._v("21")]), _vm._v(". See Pressley, "), _c('em', [_vm._v("Americans Interpret Their Civil Wa")]), _vm._v("r, 121–134, 150–162, 187– 192; Blight, "), _c('em', [_vm._v("Race and Reunion")]), _vm._v(", 343–360 Blight, "), _c('em', [_vm._v("Beyond the Battlefield")]), _vm._v(", 124–146 Shackel, "), _c('em', [_vm._v("Memory in Black and White")]), _vm._v(", 26–39 George M. Fredrickson, “Nineteenth Century American History,” in Anthony Molho and Gordon S. Wood, eds., "), _c('em', [_vm._v("Imagined Histories: American Historians Reinterpret the Past")]), _vm._v(" (Princeton, NJ, 1998), 166–170.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote22introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote22"
    }
  }, [_vm._v("22")]), _vm._v(". Wolf, "), _c('em', [_vm._v("American Jew as Patriot, Soldier and Citizen")]), _vm._v(", 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote23introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote23"
    }
  }, [_vm._v("23")]), _vm._v(". Rhodes, "), _c('em', [_vm._v("History of the United States from the Compromise of 1850")]), _vm._v("; Wilson, "), _c('em', [_vm._v("Division and Reunion, 1829–1889")]), _vm._v("; see also Pressley, "), _c('em', [_vm._v("Americans Interpret Their Civil War")]), _vm._v(", 135–148.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote24introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote24"
    }
  }, [_vm._v("24")]), _vm._v(". Wolf, "), _c('em', [_vm._v("American Jew as Patriot, Soldier and Citizen")]), _vm._v(", 104.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote25introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote25"
    }
  }, [_vm._v("25")]), _vm._v(". Max J. Kohler, “Incidents Illustrative of American Jewish Patriotism,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 4 (1896): 104.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote26introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('em', [_vm._v("The Jewish Encyclopedia")]), _vm._v(" (New York, 1906), 363.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote27introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote27"
    }
  }, [_vm._v("27")]), _vm._v(". Isaac Markens thought that Wolf had underestimated the number of Jewish soldiers by half. Max Raisin estimated that “fifteen to twenty thousand” served in the Union and Confederate armies. Max Raisin, "), _c('em', [_vm._v("A History of Jews in Modern Times")]), _vm._v(" (New York, 1923), 278; Isaac Markens, “Lincoln and the Jews,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 17 (1909): 157.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote28introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote28"
    }
  }, [_vm._v("28")]), _vm._v(". Max J. Kohler, “The Jews and the American Anti-Slavery Movement,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 5 (1897): 137.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote29introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote29"
    }
  }, [_vm._v("29")]), _vm._v(". See U. B. Phillips, "), _c('em', [_vm._v("American Negro Slavery: A Survey of the Supply, Employment and Control of Negro Labor as Determined by the Plantation Régime")]), _vm._v(" (New York, 1918); see also U. B. Phillips, "), _c('em', [_vm._v("Life and Labor in the Old South")]), _vm._v(" (Boston, 1929); "), _c('em', [_vm._v("The Slave Economy of the Old South: Selected Essays in Economic and Social History")]), _vm._v(" (Baton Rouge, LA, 1968); Novick, "), _c('em', [_vm._v("That Noble Dream")]), _vm._v(", 72–80 Pressley, "), _c('em', [_vm._v("Americans Interpret Their Civil War")]), _vm._v(", 143–146 Blight, "), _c('em', [_vm._v("Beyond the Battlefield")]), _vm._v(", 130– 140; Tulloch, "), _c('em', [_vm._v("Debate on the American Civil War Era")]), _vm._v(", 6–7.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote30introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote30"
    }
  }, [_vm._v("30")]), _vm._v(". Kohler lamented this as a “most unjustified identification of Jews with the pro-slavery cause in the public mind.” Max J. Kohler, “Judah P. Benjamin: Statesman and Jurist,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 12 (1904): 83.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "fnote31introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote31"
    }
  }, [_vm._v("31")]), _vm._v(". Kohler, “Jews and the American Anti-Slavery Movement,” 140–141.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote32introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote32"
    }
  }, [_vm._v("32")]), _vm._v(". David Einhorn was Kohler’s maternal grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote33introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote33"
    }
  }, [_vm._v("33")]), _vm._v(". Max J. Kohler, “The Jews and the American Anti-Slavery Movement II,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 9 (1901): 45–53.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote34introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote34"
    }
  }, [_vm._v("34")]), _vm._v(". For example, Lee Levinger maintained in "), _c('em', [_vm._v("A History of the Jews in the United States")]), _vm._v(" that Jewish (and Christian) immigrants were “ardent for every kind of liberty, including that of the negro.” Elma Levinger’s children’s book "), _c('em', [_vm._v("The Golden Door")]), _vm._v(" offered a melodramatic retelling of Einhorn’s escape from Baltimore, presented through the (blind) eyes of an adoring slave (a “tall Negress who might have been a queen in her native Africa”) who dies to save Einhorn’s life. Lee Levinger, "), _c('em', [_vm._v("A History of the Jews of the United States")]), _vm._v(" (Cincinnati, 1930), 192–193 Elma Levinger, "), _c('em', [_vm._v("The Golden Door: Stories of the Jews Who Had a Part in the Making of America")]), _vm._v(" (New York, 1947), 188–198.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote35introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote35"
    }
  }, [_vm._v("35")]), _vm._v(". Quoted in Kohler, “Judah P. Benjamin,” 63.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote36introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote36"
    }
  }, [_vm._v("36")]), _vm._v(". Quoted in Eli Evans, "), _c('em', [_vm._v("Judah P. Benjamin: The Jewish Confederate")]), _vm._v(" (New York, 1989), 148.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote37introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote37"
    }
  }, [_vm._v("37")]), _vm._v(". See Isaac Wise, "), _c('em', [_vm._v("Reminiscences")]), _vm._v(" (Cincinnati, 1901), 184–185. For a later repetition, and embellishment, of these same myths, see Herbert Ezekiel and Gaston Lichtenstein, "), _c('em', [_vm._v("The History of the Jews of Richmond from 1769 to 1917")]), _vm._v(" (Richmond, VA, 1917), 169. For the debunking of these claims, see Bertram Korn, “Judah P. Benjamin as a Jew,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 38:3 (1949): 153–171.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote38introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote38"
    }
  }, [_vm._v("38")]), _vm._v(". Kohler, “Judah P. Benjamin,” 83.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote39introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote39"
    }
  }, [_vm._v("39")]), _vm._v(". Max J. Kohler, “Benjamin, Judah Philip,” in Isidore Singer, ed., "), _c('em', [_vm._v("The Jewish Encyclopedia")]), _vm._v(" (New York, 1906), 28–31. Ironically, an admiring Richmond contemporary thought that Benjamin was “Hebrew in blood, English in Tenacity and grasp of purpose.” Quoted in Evans, "), _c('em', [_vm._v("Judah P. Benjamin")]), _vm._v(", 138.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote40introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote40"
    }
  }, [_vm._v("40")]), _vm._v(". Kohler, “Judah P. Benjamin,” 85.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote41introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote41"
    }
  }, [_vm._v("41")]), _vm._v(". For example, Max Raisin wrote that at the “right hand of President Jefferson Davis, sat a Jew to whom was attributed the distinction of being the ‘brains of the Confederacy,’” a man “almost fanatical in his Southern patriotism … who never for a moment lost the confidence of the President who, more than upon any other member of his official family, leaned upon him in all the weightiest of problems.” Raisin, "), _c('em', [_vm._v("A History of the Jews in Modern Times")]), _vm._v(", 279–281.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote42introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote42"
    }
  }, [_vm._v("42")]), _vm._v(". Myer Isaacs, “A Jewish Army Chaplain,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 12 (1904): 136–137.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote43introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote43"
    }
  }, [_vm._v("43")]), _vm._v(". For the cult of Lincoln (and Lee), see Pressley, "), _c('em', [_vm._v("Americans Interpret Their Civil War")]), _vm._v(", 188.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote44introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote44"
    }
  }, [_vm._v("44")]), _vm._v(". Isaacs, “Jewish Army Chaplain,” 137.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote45introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote45"
    }
  }, [_vm._v("45")]), _vm._v(". For Lincoln’s interactions with Jews, see Bertram Korn, "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(" (New York, 1970), 189–216. Simon Wolf, a political supporter of President Grant, had, in a series of newspaper articles, previously sought to absolve "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Grant of all blame for Order No. 11, “which was issued over the signature of General Grant, but of which he, at the time, had absolutely no knowledge.” Writing in 1909, Joseph Lebowich questioned the accuracy of Wolf’s interpretation but concluded that “Grant’s dealings with Jews, both before and after the issuing of Order No. 11, showed not only his freedom from the slightest taint of Antisemitism but proved that he was a friend of the Jew. … [He] was singularly free from race prejudice.” Joseph Lebowich, “General Ulysses S. Grant and the Jews,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 17 (1909): 71–79. The official papers of Ulysses S. Grant easily refute these claims and prove that quite the opposite was true. John Y. Simon, ed., "), _c('em', [_vm._v("The Papers of Ulysses S. Grant")]), _vm._v(", vol. 7, (Carbondale, IL, 1979), 50–56 John Y. Simon, ed., "), _c('em', [_vm._v("The Papers of U.S. Grant")]), _vm._v(", vol. 19 (Carbondale, IL, 1995), 18–22.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote46introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote46"
    }
  }, [_vm._v("46")]), _vm._v(". Isaac Markens, “Lincoln and the Jews,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 17 (1909): 109–165.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote47introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote47"
    }
  }, [_vm._v("47")]), _vm._v(". For example, the award of “numerous appointments and promotions in the military service” attested “Lincoln’s appreciation of the services rendered by the Jews.” Ibid., 157.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote48introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote48"
    }
  }, [_vm._v("48")]), _vm._v(". Ibid., 161.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote49introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote49"
    }
  }, [_vm._v("49")]), _vm._v(". See, for example, Charles Segal, “Isachar Zacharie: Lincoln’s Chiropodist,” "), _c('em', [_vm._v("Publication of the American Jewish Historical Society")]), _vm._v(" 43:1 (1953).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote50introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote50"
    }
  }, [_vm._v("50")]), _vm._v(". Markens, “Lincoln and the Jews,” 111. In 1860, Wise had opposed Lincoln in "), _c('em', [_vm._v("Die Deborah")]), _vm._v(", describing him as a “country squire who would look queer in the White House with his country manner.” Jonathan Sarna and Nancy Klein, "), _c('em', [_vm._v("The Jews of Cincinnati")]), _vm._v(" (Cincinnati, 1989), 53.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote51introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote51"
    }
  }, [_vm._v("51")]), _vm._v(". Emanuel Hertz, ed., "), _c('em', [_vm._v("Abraham Lincoln: The Tribute of the Synagogue")]), _vm._v(" (New York, 1927).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote52introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote52"
    }
  }, [_vm._v("52")]), _vm._v(". Raisin, "), _c('em', [_vm._v("A History of Jews in Modern Times")]), _vm._v(", 276–281.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote53introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote53"
    }
  }, [_vm._v("53")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("When the American nation was confronted by the Civil War the Jews were the first in the Union and Second to none in the Confederacy. Over three thousand Jewish soldiers, from every denomination, were among the boys in blue, and who does no know what Jadah ["), _c('em', [_vm._v("sic")]), _vm._v("] P. Benjamin did for the confederacy? The Jews of the Civil War have primarily observed Jeremiah’s instructions to the exiles of Nebuchadnezzar: “And seek the peace of the city whither I have caused you to be carried away captive and pray unto the Lord for it.” Those of the south prayed for the gray, and those of the north entreated God for the blue. "), _c('em', [_vm._v("But this was the first time in the history of Israel in exile that his sons fought against one another for a country worthy of sacrificing their lives, for a country worthy to die for and good to live in")]), _vm._v(". Many Jewish generals on both sides have distinguished themselves in numerous engagements and the bravery of the Jewish soldiers received the acclaim of their American fellow-citizens unstintingly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Simon Glazer, "), _c('em', [_vm._v("History of Israel")]), _vm._v(" (New York, 1930), 338–339 (italics added).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "fnote54introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote54"
    }
  }, [_vm._v("54")]), _vm._v(". Paul Masserman and Max Baker, "), _c('em', [_vm._v("The Jews Come to America")]), _vm._v(" (New York, 1932), 202–211 Max Margolis and Alexander Marx, "), _c('em', [_vm._v("A History of the Jewish People")]), _vm._v(" (Philadelphia, 1927), 677; Solomon Grayzel, "), _c('em', [_vm._v("A History of the Jews")]), _vm._v(" (Philadelphia, 1947), 627–627 Ismar Elbogen, "), _c('em', [_vm._v("A Century of Jewish Life")]), _vm._v(" (Philadelphia, 1944), 118–121 Anita Lebeson, "), _c('em', [_vm._v("Pilgrim People")]), _vm._v(" (New York, 1950), 255–295.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote55introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote55"
    }
  }, [_vm._v("55")]), _vm._v(". Samuel McCall, "), _c('em', [_vm._v("Patriotism of the American Jew")]), _vm._v(" (New York, 1924), 7.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote56introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote56"
    }
  }, [_vm._v("56")]), _vm._v(". Ibid., 11–13.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote57introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote57"
    }
  }, [_vm._v("57")]), _vm._v(". Lee Levinger, "), _c('em', [_vm._v("A History of the Jews in the United States")]), _vm._v(" (Cincinnati, 1930), 192–209. The book probably had more influence on public knowledge of American Jewish history than any other textbook before or since. See Jonathan Krasner, “Representations of Self and Other in American Jewish History and Social Studies Schoolbooks: An Exploration of the Changing Shape of American Jewish Identity” (Ph.D. diss., Brandeis University, 2002), 391–407.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote58introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote58"
    }
  }, [_vm._v("58")]), _vm._v(". The review section at the end of the chapter included such leading questions as “Did the Jews serve in the Civil War in proportion to their number in the general population?” “Tell one story of contact between Lincoln and some Jew” and “What was Abraham Lincoln’s attitude toward religion? Toward various peoples of different race or religion from his own?” Levinger, "), _c('em', [_vm._v("A History of the Jews in the United States")]), _vm._v(", 208"), _c('em', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote59introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote59"
    }
  }, [_vm._v("59")]), _vm._v(". “He used to be at his desk at eight in the morning and leave it, day after day, at one or two in the morning; through it all he preserved his calm, his courtesy, and his cheerful smile.” Ibid., 205.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote60introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote60"
    }
  }, [_vm._v("60")]), _vm._v(". Ibid., 209.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote61introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote61"
    }
  }, [_vm._v("61")]), _vm._v(". Oscar Leonard, "), _c('em', [_vm._v("Americans All: Grandfather Tells Benny How Jews Helped in the Discovery and Building of America")]), _vm._v(" (New York, 1945), 114–130.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote62introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote62"
    }
  }, [_vm._v("62")]), _vm._v(". Ibid., 115, 122. Elma Levinger offered a similar lesson, spoken by a school-teacher in her story: “He [Lincoln] is not one of our people, yet I believe he is more like our Hebrew prophets than any man, Jew or Christian, living today.” Elma Levinger, "), _c('em', [_vm._v("The Golden Door: Stories of the Jews Who Had a Part in the Making of America")]), _vm._v(" (New York, 1947), 188.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote63introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote63"
    }
  }, [_vm._v("63")]), _vm._v(". The chapter started with an entirely fictional account of Benjamin intervening to halt the whipping of a slave:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("Suddenly he stopped talking and jumped the carriage. He ran toward the sound of a cruel, angry voice and the swift lashing of a whip. The fury in Benjamin’s voice was controlled as he spoke in low, steady tones. “Who gave you the right to beat a helpless slave?” Before him stood his overseer, a whip now hanging limply at his side, and a frightened, trembling Negro. The man stammered hesitantly. “But he sassed me …” “You know my wishes in these matters. Complaints are to be brought before me. I will not tolerate whippings on my plantation. Is that clear?” The overseer muttered: "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("“I worked on plantations before, for gentlemen …” Benjamin’s face was severe as he cut in. “I know. You never worked for a Jew before.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leonard, "), _c('em', [_vm._v("Americans All")]), _vm._v(", 124.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote64introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote64"
    }
  }, [_vm._v("64")]), _vm._v(". See Tina Levitan, "), _c('em', [_vm._v("The Firsts of American Jewish History, 1492–1951")]), _vm._v(" (New York, 1952), 74.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote65introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote65"
    }
  }, [_vm._v("65")]), _vm._v(". He set out in “glowing language [to] paint brilliant pictures of feats of prowess, of unselfish devotion, of supreme sacrifice. A picture with colors of unfading hue that will live for all time, a perpetual monument to the valor of Jewry.” Sydney Gumpertz, "), _c('em', [_vm._v("The Jewish Legion of Valor")]), _vm._v(" (New York, 1946), ix, 81–83.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote66introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote66"
    }
  }, [_vm._v("66")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("A supreme principle was involved, the sentiments of the combatants were enlisted on the side of the ideals. … It is not our intention to present a case of right or wrong, to censure or commend the North or South, but it is a source of additional pride that Jews in their thousands again proved their manhood by flocking to the Stars and Stripes of the United States and the Stars and Bars of the Confederacy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ibid., 81–83.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote67introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote67"
    }
  }, [_vm._v("67")]), _vm._v(". The world “must realize that he [Hitler] was moved not so much by hatred as by the fear that Jewish ideals, which are an integral part of our Judeo-Christian civilization, were the greatest obstacle to the success of his barbaric ‘new order.’” J. George Fredman and Louis Falk, "), _c('em', [_vm._v("Jews in American Wars")]), _vm._v(" (Hoboken, NJ, 1946), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote68introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote68"
    }
  }, [_vm._v("68")]), _vm._v(". For the new material, see pages 48–66 in the 1954 edition.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote69introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote69"
    }
  }, [_vm._v("69")]), _vm._v(". Philip Foner, "), _c('em', [_vm._v("The Jews in American History, 1654–1865")]), _vm._v(" (New York, 1945). For Foner, see Ellen Fitzpatrick, "), _c('em', [_vm._v("History’s Memory: Writing America’s Past, 1880– 1980")]), _vm._v(" (Cambridge, MA, 2002), 226–227 Novick, "), _c('em', [_vm._v("That Noble Dream")]), _vm._v(", 225, 327.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote70introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote70"
    }
  }, [_vm._v("70")]), _vm._v(". Foner, "), _c('em', [_vm._v("Jews in American History")]), _vm._v(", 54–57, 70–72.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote71introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote71"
    }
  }, [_vm._v("71")]), _vm._v(". Ibid., 72–75.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote72introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote72"
    }
  }, [_vm._v("72")]), _vm._v(". Ibid., 57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote73introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote73"
    }
  }, [_vm._v("73")]), _vm._v(". Ibid., 76.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote74introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote74"
    }
  }, [_vm._v("74")]), _vm._v(". Tina Levitan’s "), _c('em', [_vm._v("The Firsts of American Jewish History")]), _vm._v(", published in 1952 and intended for a young audience, followed Foner’s lead in reinterpreting the Civil War to teach progressive lessons. Levitan, "), _c('em', [_vm._v("The Firsts of American Jewish History")]), _vm._v(", 74.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote75introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote75"
    }
  }, [_vm._v("75")]), _vm._v(". See Tulloch, "), _c('em', [_vm._v("The Debate on the American Civil War Era")]), _vm._v(", 18. For a critique of Marcus’s treatment of Jewish slaveholding, see Jonathan Schorsch, “American Jewish Historians, Colonial Jews and Blacks, and the Limits of "), _c('em', [_vm._v("Wissenschaft")]), _vm._v(": A Critical Review,” "), _c('em', [_vm._v("Jewish Social Studies")]), _vm._v(" 6:2 (2000): 108–111.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote76introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote76"
    }
  }, [_vm._v("76")]), _vm._v(". Korn, "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v("; Korn, “Judah P. Benjamin as a Jew.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote77introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote77"
    }
  }, [_vm._v("77")]), _vm._v(". Korn, "), _c('em', [_vm._v("American Jewry and the Civil War")]), _vm._v(", 168 (italics in the original).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "fnote78introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote78"
    }
  }, [_vm._v("78")]), _vm._v(". For the Civil War Centennial Jewish Historical Commission, see "), _c('em', [_vm._v("American Jewish Historical Quarterly")]), _vm._v(" 53:4 (1964): 324–325 and "), _c('em', [_vm._v("American Jewish Historical Quarterly")]), _vm._v(" 50:4 (1961): 427. For the Civil War exhibition, see Isidore Meyer, ed., "), _c('em', [_vm._v("The American Jew in the Civil War: Catalog of the Exhibit of the Civil War Centennial Commission")]), _vm._v(" (New York, 1962). See also "), _c('em', [_vm._v("Journal of the Southern Jewish Historical Society")]), _vm._v(" 1:1 (1963).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote79introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote79"
    }
  }, [_vm._v("79")]), _vm._v(". See also "), _c('em', [_vm._v("B’nai B’rith Voice")]), _vm._v(", January 1962, 4, 10; Proceedings of Annual Convention, 1953–1954, B’nai B’rith collection, MS 180, American Jewish Archives.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote80introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote80"
    }
  }, [_vm._v("80")]), _vm._v(". "), _c('em', [_vm._v("Huntsville Times")]), _vm._v(", March 8, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "fnote81introduction"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introductionfnote81"
    }
  }, [_vm._v("81")]), _vm._v(". Resolutions Presented at the 1963 Annual Convention of the Alabama State Association of B’nai B’rith, 20–21 April 1963, box 13, MS 180, American Jewish Archives.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e8c9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 78
// module chunks = 0